import {
  INIT_INTERVIEW,
  RECORD_ANSWER,
  FETCH_METRIC_STEP_START,
  FETCH_METRIC_STEP_SUCCESS,
  FETCH_METRIC_STEP_ERROR,
  FETCH_PERSONNEL_STEP_START,
  FETCH_PERSONNEL_STEP_SUCCESS,
  FETCH_PERSONNEL_STEP_ERROR,
  FETCH_OPERATIONAL_STEP_START,
  FETCH_OPERATIONAL_STEP_SUCCESS,
  FETCH_OPERATIONAL_STEP_ERROR,
} from "../actions/types";

const INITIAL_STATE = {
  mode: null,              // "metrics", "personnel", "operational"
  industry: "",
  metrics: [],             // only for metrics mode
  outcome: "",             // only for efficiency mode
  history: [],             // [{ role, content }]
  suggestedJson: {},       // latest AI suggestions
  done: false,
  loading: false,
  error: null,
};

export default function interviewReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case INIT_INTERVIEW: {
      const { industry, data, mode } = action.payload;
      return {
        ...INITIAL_STATE,
        mode,
        industry,
        metrics: mode === "metrics" ? data : [],
        outcome: mode === "personnel" || mode === "operational" ? data : "",
      };
    }

    case RECORD_ANSWER: {
      return {
        ...state,
        history: [...state.history, { role: "user", content: action.payload }],
      };
    }

    case FETCH_METRIC_STEP_START:
    case FETCH_PERSONNEL_STEP_START:
    case FETCH_OPERATIONAL_STEP_START:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_METRIC_STEP_SUCCESS:
    case FETCH_PERSONNEL_STEP_SUCCESS:
    case FETCH_OPERATIONAL_STEP_SUCCESS: {
      const { next_question, suggested_json, done } = action.payload;
      return {
        ...state,
        loading: false,
        history: [
          ...state.history,
          { role: "assistant", content: next_question }
        ],
        suggestedJson: suggested_json,
        done,
      };
    }

    case FETCH_METRIC_STEP_ERROR:
    case FETCH_PERSONNEL_STEP_ERROR:
    case FETCH_OPERATIONAL_STEP_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
}